// removed by extract-text-webpack-plugin
module.exports = {"CrtPrint":"_2pcBZ9lyF5KEnje1bMElUn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModuleCertificate/styles.css
// module id = 689
// module chunks = 0